// extracted by mini-css-extract-plugin
export default {"component":"HooksPage_component__ikM1O","row":"HooksPage_row__BcAxA","col":"HooksPage_col__bRUqb"};